import { VideobroadcastWidgetWrapper } from '../../videobroadcast-widget/VideobroadcastWidget';
import type { VideobroadcastWidgetEntity } from '../../videobroadcast-widget/VideobroadcastWidget.entity';

import type { TRenderWidget, TWidgetRendererOptions } from './WidgetRendererService';

export function renderVideobroadcastWidget(
  widget: VideobroadcastWidgetEntity,
  options: TWidgetRendererOptions,
): TRenderWidget {
  return ({ onCreateVideobroadcastWidget }) => (
    <VideobroadcastWidgetWrapper
      entity={widget}
      options={options}
      onCreateVideobroadcastWidget={onCreateVideobroadcastWidget}
    />
  );
}
